export const getIsOcrDataLoading = state => state.ocrData.ocrLoading || false;
export const getOcrData = state => state.ocrData.ocrData || {};
export const getOcrError = (state, key) => state.ocrData.ocrError || {};
